import { render, staticRenderFns } from "./OtherCashesNewForm.vue?vue&type=template&id=a7a70f0c"
import script from "./OtherCashesNewForm.vue?vue&type=script&lang=js"
export * from "./OtherCashesNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports